// src/config.js
let configs = {};

export const loadConfig = async () => {
  const res = await fetch('/environments/config.json');
  configs = await res.json();
};

export const getConfig = (key) => configs[key];

export const getConfigAll = () => configs;
